import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/apps/web/app/error.tsx");
